
/**
 * App configuration
 */
class APPConfig {
  /**
   * api url endpoint
   */
  static API_URL: string = import.meta.env.VITE_API_ENDPOINT ? import.meta.env.VITE_API_ENDPOINT : 'http://localhost:8080/api';
  static SOCKET_URL: string = import.meta.env.VITE_API_SOCKET_URL ? import.meta.env.VITE_API_SOCKET_URL : 'http://localhost:5050';
  static DEFAULT_TIMEZONE: string = import.meta.env.VITE_DEFAULT_TIMEZONE ? import.meta.env.VITE_DEFAULT_TIMEZONE : 'America/New_York';
  static BUGSNAG_APIKEY: string = import.meta.env.VITE_BUGSNAG_APIKEY ? import.meta.env.VITE_BUGSNAG_APIKEY : '';
  static CUSTOMER_ENDPOINT: string = import.meta.env.VITE_CUSTOMER_ENDPOINT ? import.meta.env.VITE_CUSTOMER_ENDPOINT : '';
  static LOGO: string = import.meta.env.VITE_LOGO ? import.meta.env.VITE_LOGO : "";
  static IS_ENABLE_PRINTING: string = import.meta.env.VITE_IS_ENABLE_PRINTING ? import.meta.env.VITE_IS_ENABLE_PRINTING : 'false';
}

export default APPConfig;